jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
	security: {
		_charsToHTMLEntityMap: {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#39;',
			'`': '&#96;',
		},

		_htmlEntityToCharMap: {
			'&amp;': '&',
			'&lt;': '<',
			'&gt;': '>',
			'&quot;': '"',
			'&#39;': "'",
			'&#96;': '`',
		},

		escapeStringForHtml: function (string) {
			const _this = this;
			return String(string).replace(/[&<>"'`]/g, function (m) {
				return _this._charsToHTMLEntityMap[m];
			});
		},

		/**
		 * Always use this Method to sanitize HTML-Strings. (BUT not for Backstage-Components, there use a local sanitizeEvilHtml() instead)
		 * @param string
		 * @returns {string} Cleaner String for security reasons
		 */
		sanitizeEvilHtml: function (string) {
			// TODO when ready: https://developer.mozilla.org/en-US/docs/Web/API/HTML_Sanitizer_API
			if (string.indexOf('matchingWheelData') > -1) {
				// MatchingWheel needs to write a script-Tag. We should not remove that for this call. Remove after new MatchingWheel (maybe 2024)
				return String(string).replace(
					/\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi,
					'',
				);
			} else {
				return String(string).replace(
					/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi,
					'',
				);
			}
		},

		/**
		 * For Text that should be used in Textareas, we don't want to remove the HTML-Entities
		 * @param string
		 * @returns {string} Clean String for Textareas
		 */
		htmlEntitiesToChars: function (string) {
			const _this = this;

			return String(string).replace(/&[^;]+;/g, function (m) {
				if (_this._htmlEntityToCharMap[m] !== '') {
					return _this._htmlEntityToCharMap[m];
				} else {
					return m;
				}
			});
		},

		csrf: {
			getToken: function () {
				let csrfToken = '';
				if (document.querySelector('meta[name="_csrf"]') !== null) {
					csrfToken = document.querySelector('meta[name="_csrf"]').getAttribute('content');
				}
				return csrfToken;
			},

			updateToken: function (token) {
				document.querySelector('meta[name="_csrf"]')?.setAttribute('content', token);
				this.setValidstate(true);
			},

			hasValidToken: function () {
				return document.querySelector('meta[name=_csrf]')?.hasAttribute('data-invalid') === false;
			},

			setValidstate: function (state) {
				if (state === true) {
					document.querySelector('meta[name=_csrf]')?.removeAttribute('data-invalid');
				} else {
					document.querySelector('meta[name=_csrf]').dataset.invalid = true;
				}
			},
		},
	},
});
